import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConfigService } from 'wwwroot/app/services/config.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'form-file',
  templateUrl: './form-file.component.html',
  styleUrls: ['./form-file.component.css']
})
export class FormFileComponent {
  config;
  group: FormGroup;

  private file: File | null = null;

  constructor(private configService: ConfigService) { }

  onFileChange(event) {
    const file = event && event.target.files[0];
    this.file = file;
    this.configService.fileUpload(file, this.config);
  }

}
